document.addEventListener('DOMContentLoaded', () => {
  const sectorFilter = document.getElementById('sector-filter');
  const jurisdictionFilter = document.getElementById('jurisdiction-filter');
  const jurisdictionTabs = document.getElementById('jurisdiction-tabs');
  const coursesList = document.getElementById('courses-list');
  const searchInput = document.getElementById('courses-search');
  const countNum = document.getElementById('count-num');

  if (!sectorFilter || !coursesList) return;

  const accordions = coursesList.querySelectorAll('.course-accordion');
  let activeSector = 'all';
  let activeJurisdiction = null;
  let searchQuery = '';

  const sectorToRegulators = {
    'legal': ['SRA', 'LSS', 'ADGM'],
    'financial-services': ['FCA'],
    'gambling': ['Gambling Commission'],
    'general': []
  };

  function updateSectorCounts() {
    const allCount = accordions.length;
    const countAll = document.getElementById('count-all');
    if (countAll) countAll.textContent = allCount;

    Object.keys(sectorToRegulators).forEach(sector => {
      let count = 0;
      accordions.forEach(acc => {
        const s = acc.getAttribute('data-sector');
        if (sector === 'general') {
          if (s === 'general') count++;
        } else {
          if (s === sector || s === 'general') count++;
        }
      });
      const el = document.getElementById('count-' + sector);
      if (el) el.textContent = count;
    });
  }

  function buildJurisdictionTabs() {
    if (!jurisdictionTabs) return;
    jurisdictionTabs.innerHTML = '';

    if (activeSector === 'all' || !sectorToRegulators[activeSector]) {
      jurisdictionFilter.hidden = true;
      return;
    }

    const regs = sectorToRegulators[activeSector];

    if (regs.length <= 1) {
      jurisdictionFilter.hidden = true;
      activeJurisdiction = null;
      return;
    }

    const allBtn = document.createElement('button');
    allBtn.className = 'jurisdiction-tab active';
    allBtn.setAttribute('data-jurisdiction', 'all');
    allBtn.textContent = 'All Jurisdictions';
    jurisdictionTabs.appendChild(allBtn);

    regs.forEach(reg => {
      const btn = document.createElement('button');
      btn.className = 'jurisdiction-tab';
      btn.setAttribute('data-jurisdiction', reg);
      btn.textContent = reg;
      jurisdictionTabs.appendChild(btn);
    });

    jurisdictionFilter.hidden = false;
    activeJurisdiction = null;
  }

  function filterCourses() {
    let visible = 0;
    accordions.forEach(acc => {
      const sector = acc.getAttribute('data-sector');
      const reg = acc.getAttribute('data-regulatory');
      const name = acc.getAttribute('data-name');

      let matchesSector = true;
      let matchesJurisdiction = true;

      if (activeSector !== 'all') {
        if (activeSector === 'general') {
          matchesSector = (sector === 'general');
        } else {
          matchesSector = (sector === activeSector || sector === 'general');
          const regs = sectorToRegulators[activeSector] || [];
          if (activeJurisdiction && activeJurisdiction !== 'all') {
            matchesJurisdiction = (reg === activeJurisdiction || sector === 'general');
          }
        }
      }

      const matchesSearch = !searchQuery || name.includes(searchQuery);

      if (matchesSector && matchesJurisdiction && matchesSearch) {
        acc.classList.remove('hidden');
        visible++;
      } else {
        acc.classList.add('hidden');
        acc.classList.remove('open');
        const body = acc.querySelector('.course-accordion-body');
        if (body) body.style.maxHeight = '0';
      }
    });

    if (countNum) countNum.textContent = visible;
  }

  sectorFilter.addEventListener('click', (e) => {
    const btn = e.target.closest('.sector-btn');
    if (!btn) return;

    const sector = btn.getAttribute('data-sector');
    activeSector = sector;
    activeJurisdiction = null;

    sectorFilter.querySelectorAll('.sector-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    if (sector === 'all') {
      jurisdictionFilter.hidden = true;
    } else {
      buildJurisdictionTabs();
    }

    filterCourses();
  });

  if (jurisdictionTabs) {
    jurisdictionTabs.addEventListener('click', (e) => {
      const tab = e.target.closest('.jurisdiction-tab');
      if (!tab) return;

      const jur = tab.getAttribute('data-jurisdiction');
      activeJurisdiction = jur;

      jurisdictionTabs.querySelectorAll('.jurisdiction-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      filterCourses();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      searchQuery = e.target.value.toLowerCase().trim();
      filterCourses();
    });
  }

  coursesList.addEventListener('click', (e) => {
    const header = e.target.closest('.course-accordion-header');
    if (header) {
      const acc = header.closest('.course-accordion');
      const body = acc.querySelector('.course-accordion-body');
      const isOpen = acc.classList.contains('open');

      if (isOpen) {
        acc.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
        body.style.maxHeight = '0';
      } else {
        acc.classList.add('open');
        header.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
        if (window._paq) {
          window._paq.push(['trackEvent', 'CoursesPage', 'accordion_open', acc.getAttribute('data-name')]);
        }
      }
      return;
    }

    const detailToggle = e.target.closest('.course-detail-toggle');
    if (detailToggle) {
      const acc = detailToggle.closest('.course-accordion');
      const detail = acc.querySelector('.course-accordion-detail');
      const body = acc.querySelector('.course-accordion-body');
      const isOpen = detail.classList.contains('open');
      const toggleText = detailToggle.querySelector('.detail-toggle-text');

      if (isOpen) {
        detail.classList.remove('open');
        detail.style.maxHeight = '0';
        detailToggle.setAttribute('aria-expanded', 'false');
        if (toggleText) toggleText.textContent = 'Read more';
      } else {
        detail.classList.add('open');
        detail.style.maxHeight = detail.scrollHeight + 'px';
        detailToggle.setAttribute('aria-expanded', 'true');
        if (toggleText) toggleText.textContent = 'Show less';
        if (window._paq) {
          window._paq.push(['trackEvent', 'CoursesPage', 'detail_open', acc.getAttribute('data-name')]);
        }
      }

      requestAnimationFrame(() => {
        body.style.maxHeight = body.scrollHeight + detail.scrollHeight + 200 + 'px';
      });
    }
  });

  updateSectorCounts();
  filterCourses();
});
